// extracted by mini-css-extract-plugin
export default {"ag-grid-height":"SalesPersonGrid_ag-grid-height__8p6ZH"};